module.exports = __webpack_public_path__ + "static/50-f4e82b7b1a6a76d738436c202d2e681c.png";